import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { CommonResponse } from "@/api/response";
import { WinRequest } from "@/api/ticket-lottery/request";
import * as TicketLotteryAPI from "@/api/ticket-lottery";
import { isSuccess } from "@/api/response";

const MODULE_NAME = "ticket-lottery/register";

/**
 * 当選確定API（/win-ticket-lottery）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Win extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  // MutationActions
  @MutationAction
  async win(winRequest: WinRequest) {
    const commonResponse = await TicketLotteryAPI.win(winRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clear() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Win);
